"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeUrlMappings = void 0;
var codec_1 = require("../codec");
exports.typeUrlMappings = {
    '/cosmos.base.v1beta1.Coin': codec_1.cosmos.base.v1beta1.Coin,
    '/cosmos.bank.v1beta1.MsgSend': codec_1.cosmos.bank.v1beta1.MsgSend,
    '/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward': codec_1.cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward,
    '/cosmos.staking.v1beta1.MsgCreateValidator': codec_1.cosmos.staking.v1beta1.MsgCreateValidator,
    '/cosmos.staking.v1beta1.MsgBeginRedelegate': codec_1.cosmos.staking.v1beta1.MsgBeginRedelegate,
    '/cosmos.staking.v1beta1.MsgEditValidator': codec_1.cosmos.staking.v1beta1.MsgEditValidator,
    '/cosmos.staking.v1beta1.MsgDelegate': codec_1.cosmos.staking.v1beta1.MsgDelegate,
    '/cosmos.staking.v1beta1.MsgUndelegate': codec_1.cosmos.staking.v1beta1.MsgUndelegate,
    '/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission': codec_1.cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission,
    '/cosmos.crypto.ed25519.PubKey': codec_1.cosmos.crypto.ed25519.PubKey,
    '/cosmos.crypto.secp256k1.PubKey': codec_1.cosmos.crypto.secp256k1.PubKey,
    '/cosmos.gov.v1beta1.MsgDeposit': codec_1.cosmos.gov.v1beta1.MsgDeposit,
    '/cosmos.gov.v1beta1.MsgVote': codec_1.cosmos.gov.v1beta1.MsgVote,
    '/cosmos.gov.v1beta1.MsgSubmitProposal': codec_1.cosmos.gov.v1beta1.MsgSubmitProposal,
    '/google.protobuf.Any': codec_1.google.protobuf.Any,
    '/cosmos.distribution.v1beta1.MsgSetWithdrawAddress': codec_1.cosmos.distribution.v1beta1.MsgSetWithdrawAddress,
    '/cosmos.distribution.v1beta1.MsgFundCommunityPool': codec_1.cosmos.distribution.v1beta1.MsgFundCommunityPool,
    '/chainmain.nft.v1.MsgIssueDenom': codec_1.chainmain.nft.v1.MsgIssueDenom,
    '/chainmain.nft.v1.MsgMintNFT': codec_1.chainmain.nft.v1.MsgMintNFT,
    '/chainmain.nft.v1.MsgEditNFT': codec_1.chainmain.nft.v1.MsgEditNFT,
    '/chainmain.nft.v1.MsgTransferNFT': codec_1.chainmain.nft.v1.MsgTransferNFT,
    '/chainmain.nft.v1.MsgBurnNFT': codec_1.chainmain.nft.v1.MsgBurnNFT,
};
//# sourceMappingURL=typeurls.js.map